<template>
  <FlickitySlider class="similarAccommodationsSlider__Listing" :options="flickityOptions" :with-progress="true" customClass="similarAccommodationsSlider__Flickity">
    <div v-for="item in locations" class="similarAccommodationsSlider__Item">
      <template v-if="Object.keys(item).length">
        <FlarePicture
          v-if="item.gallery?.[0]"
          :src="{
            1920: { src: item.gallery[0], width: 600, height: 450, size: 'both', crop: 'fill' },
          }"
          :alt="item.gallery[0].alt"
        />
  
        <div>
          <div class="similarAccommodationsSlider__Infos">
            <div class="similarAccommodationsSlider__Location">
              <Icon name="location" />
              <template v-if="item.place?.name">{{ item.place.name }}</template><template v-if="item.region?.name">, {{ item.region.name }}</template>
            </div>
  
            <div class="similarAccommodationsSlider__Stars">
              <Icon name="star" v-for="i in item.category_rating" />
            </div>
          </div>
          
          <h3 v-text="item.name" />
  
          <div v-if="item.price_end_of_year?.price_from" class="similarAccommodationsSlider__PriceWrapper">
            {{ $t('from') }} {{ formatPrice(item.price_end_of_year.price_from, item.price_end_of_year.currency, lang, true) }} <template v-if="item.price_from_description">{{ item.price_from_description }}</template>
          </div>
        </div>
        
        <nuxt-link :to="item.sef">{{ item.name }}</nuxt-link>
      </template>
    </div>
  </FlickitySlider>
</template>

<script setup>
  defineProps({
    locations: {},
    flickityOptions: {
      type: Object
    }
  })

  const { lang } = useLanguage();
</script>

<style lang="scss">
  @import url('@/assets/styles/components/_similarAccommodationsSlider.scss');
</style>